import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'
import { TicketTypeGroupOptions } from '@/modules/Ticket/types/utils'
import FormLabel from '@/components/Form/FormLabel'
import helpContent from '@/modules/Ticket/help/ticket-group-type-help.md'

interface Props {
    control: Control<any>
    disabled?: boolean
    onChange?: (value: string) => void
}

const TicketGroupType: React.FC<Props> = ({
    control,
    disabled = false,
    onChange,
}) => {
    const { t } = useTranslation()

    return (
        <div>
            <FormLabel
                label={t('ticket-type-group')}
                helpContent={helpContent}
                helpTitle={t('ticket-type-group-help')}
            />
            <FormItem
                control={control}
                name="ticket_type_group"
                type="select"
                placeholder={t('ticket-type-group')}
                options={TicketTypeGroupOptions(t)}
                disabled={disabled}
                onChangeAfterHookForm={(option) => {
                    if (onChange) {
                        onChange(option?.value || option)
                    }
                }}
                allowClear={false}
            />
        </div>
    )
}

export default TicketGroupType
